export default __webpack_public_path__ + "static/account-843bb09842dc029db9aaec2e452088bf.png";